import script from "./QuanLyCongTrinh.vue?vue&type=script&setup=true&lang=js"
export * from "./QuanLyCongTrinh.vue?vue&type=script&setup=true&lang=js"

import "./QuanLyCongTrinh.vue?vue&type=style&index=0&id=194f3c66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-194f3c66"]])

export default __exports__